import React from "react";
import classes from "./FilterGroup.module.css";

const FilterGroup = ({ children, align = "horizontal", style = {} }) => {
  return (
    <div
      className={`${classes["filter-group"]} ${
        align === "vertical" && classes["filter-group-vertical"]
      }`}
      style={{ ...style }}
    >
      {children}
    </div>
  );
};

export default FilterGroup;
